export class Email {
  // source: https://ihateregex.io/expr/email
  public static readonly EMAIL_REGEX = /^[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+$/

  public static isValid(email: string): boolean {
    return this.EMAIL_REGEX.test(email)
  }
}
